import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Calendar from '../Calendar';
import CalendarFilter from '../CalendarFilter';

import { StyledCalendarContainer, DivError, SpanError } from './index.styled';
import { getCalendarEvents } from '../../utils/calendar';
import CalendarSkeleton from '../CalendarSkeleton';

const CalendarContainer = ({
	sectors,
	skills,
	resources,
	selectedActivity,
	setSelectedActivity,
	setNewComment,
	newComment,
	changeFiliale,
	isVersionPC,
	refreshData,
	canEditPlanning,
}) => {
	const [selectedResource, setSelectedResource] = useState(
		resources[0] ? resources[0] : null,
	);
	window.history.pushState({}, '', '/planning');
	const [search, setSearch] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [planning, setPlanning] = useState([]);
	const [errorApi, setErrorApi] = useState(false);
	const fetchPlanning = async (idResource) => {
		// fetch planning
		setIsLoading(true);
		const res = await getCalendarEvents(idResource);

		if (res && res?.codeError) {
			setErrorApi(true);
			return setPlanning([]);
		}
		if (res) {
			setIsLoading(false);
			setErrorApi(false);
			return setPlanning(res);
		}
		setIsLoading(false);
		return setPlanning([]);
	};

	useEffect(() => {
		if (selectedResource?.id && selectedResource?.code) {
			fetchPlanning(selectedResource.id);
		}
	}, [selectedResource]);

	useEffect(() => {
		if (refreshData && selectedResource?.id && selectedResource?.code) {
			fetchPlanning(selectedResource.id);
		}
	}, [refreshData]);

	const [filters, setFilters] = useState({
		resources:
			resources?.length > 0
				? resources.map((resource) => {
						let selected = false;
						if (
							selectedActivity?.resource?.name === resource.name
						) {
							selected = true;
						}
						return {
							...resource,
							selected,
						};
				  })
				: [],
		skills: skills?.length > 0 ? skills : [],
		sectors: sectors?.length > 0 ? sectors : [],
	});

	useEffect(() => {
		setFilters({
			resources:
				resources?.length > 0
					? resources.map((resource) => {
							let selected = false;
							if (
								selectedActivity?.resource?.name ===
								resource.name
							) {
								selected = true;
							}
							return {
								...resource,
								selected,
							};
					  })
					: [],
			skills: skills?.length > 0 ? skills : [],
			sectors: sectors?.length > 0 ? sectors : [],
		});
	}, [sectors, skills, resources]);

	useEffect(() => {
		if (search?.length === 0) {
			setFilters({
				...filters,
				resources,
			});
		} else {
			const filteredResources = resources.filter((resource) =>
				resource.code.toLowerCase().includes(search.toLowerCase()),
			);
			setFilters({
				...filters,
				resources: filteredResources,
			});
		}
	}, [search]);

	/* 	useEffect(() => {
		if (selectedActivity?.resource?.name) {
			setSelectedResource(selectedActivity.resource);
		}
	}, [selectedActivity]); */

	const updateResource = (resource) => {
		setSelectedResource(resource);
	};

	return (
		<StyledCalendarContainer ismobile={!isVersionPC()}>
			<>
				<CalendarFilter
					filters={filters}
					setFilters={setFilters}
					selectedResource={selectedResource}
					setSelectedResource={setSelectedResource}
					changeFiliale={changeFiliale}
					isVersionPC={isVersionPC}
					refreshData={refreshData}
				/>
				{(() => {
					if (!selectedResource) {
						return (
							<DivError>
								<SpanError>
									Aucun planning à afficher.{' '}
								</SpanError>
							</DivError>
						);
					}
					if (errorApi) {
						return (
							<DivError>
								<SpanError>
									Suite à un incident technique, aucun
									planning n&apos;est accessible.{' '}
								</SpanError>
							</DivError>
						);
					}
					if (isLoading) {
						return <CalendarSkeleton />;
					}
					return (
						<Calendar
							selectedResource={selectedResource}
							setSelectedResource={setSelectedResource}
							planning={planning}
							selectedActivity={selectedActivity}
							setSelectedActivity={setSelectedActivity}
							setNewComment={setNewComment}
							newComment={newComment}
							isVersionPC={isVersionPC}
							canEditPlanning={canEditPlanning}
						/>
					);
				})()}
			</>
		</StyledCalendarContainer>
	);
};

CalendarContainer.propTypes = {
	sectors: PropTypes.array,
	skills: PropTypes.array,
	resources: PropTypes.array,
	selectedActivity: PropTypes.object,
	setSelectedActivity: PropTypes.func,
	setNewComment: PropTypes.func,
	newComment: PropTypes,
	changeFiliale: PropTypes.string,
	isVersionPC: PropTypes.func,
	refreshData: PropTypes.bool,
	canEditPlanning: PropTypes.bool,
};

export default CalendarContainer;
